import SvgSearchClose from '@img/icons/search-close.svg';
import SvgSearch from '@img/icons/search.svg';
import { Divide as Hamburger } from 'hamburger-react';
import * as React from 'react';
import S from './MobileHeader.styles';
const MobileHeader = ({ isActive, isSearchActive, reduced = false, onNavigationToggle, onSearchToggle, }) => {
    return (React.createElement(S.Container, null,
        !reduced && (React.createElement(S.Button, { onClick: (event) => {
                event.preventDefault();
                onSearchToggle();
            }, "aria-label": isSearchActive ? 'Toggle Search Closed' : 'Toggle Search Open' }, isSearchActive ? React.createElement(SvgSearchClose, null) : React.createElement(SvgSearch, null))),
        !reduced && (React.createElement(S.Button, { onClick: (event) => {
                event.preventDefault();
                onNavigationToggle();
            }, "aria-label": isActive ? 'Toggle Menu Closed' : 'Toggle Menu Open' },
            React.createElement(Hamburger, { color: "currentColor", size: 28, toggled: isActive, label: "Toggle Menu Icon" })))));
};
export default MobileHeader;
